<template>
  <FilterOverview
    :isInitiallyLoading="false"
    :showFilterInitially="false"
    :showFilterButton="false"
    title="KPI Leading"
  >
    <template #toolbar-left>
      <b-button-group size="sm" class="mr-4" style="width: 300px">
        <b-button
          v-for="kpiSite in kpiSites"
          :disabled="isBusy"
          :key="kpiSite"
          class="mr-1"
          :id="kpiSite"
          :variant="kpiSite === 'Leading' ? 'primary' : ''"
          style="width: 33%"
          :to="'/reisetermine/fvc/kpi-' + kpiSite.toLowerCase()"
        >
          {{ kpiSite }}
        </b-button>
      </b-button-group>
      <DateRangePicker
        :disabled="isBusy"
        style="width: 180px"
        isWeeklyDaterangePicker
        placeholder="Zeitraum"
        :value="zeitraumSelected"
        @input="setZeitraum"
      />
      <template v-if="isAnyKpiFilterApplied">
        <div class="subheader-separator subheader-separator-ver mt-4 mb-2 mx-4 bg-gray-300"></div>
        <div
          class="icon-button d-flex align-items-center justify-content-center text-danger"
          style="width: 36px; min-width: 36px; height: 38px"
          @click="onResetFilter"
          v-b-tooltip.hover.bottom
          title="Filter zurücksetzen"
        >
          <FunnelX :size="20" />
        </div>
      </template>
    </template>

    <template #toolbar-right>
      <b-button size="sm" class="dialog-btn-secondary" @click="showFilter = !showFilter">
        <Funnel :size="16" class="mr-1" style="color: #464e5f" />
        Filter
      </b-button>
    </template>

    <template #table>
      <FilterDrawer :show="showFilter" @update:show="showFilter = $event">
        <KPIFilter @apply="showFilter = false" @cancel="showFilter = false" />
      </FilterDrawer>
      <b-overlay :show="isBusy" opacity="1">
        <div class="card card-custom">
          <div
            class="kpi-grid"
            style="display: grid; gap: 1rem; padding: 1rem; grid-template-columns: repeat(2, 1fr)"
          >
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIs?.gesamtverteilungStatusFrankfurtGesamt"
              :fillArray="fills"
              :title="'Status FRA: Gesamt'"
            />
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungFraGesamt"
              :fillArray="fillsStatusNachBearbeitung"
              :title="'Status nach Bearbeitung FRA: Gesamt'"
              :innerLabelSubtitle="'positiv'"
              :doNotShowTypes="['Aufpreis <200', 'Total']"
              :ausschlussTyp="ausschlussTypenStatusNachBearbeitung"
              :totalOverwrite="
                getTotalOverwrite(getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungFraGesamt)
              "
              :showPercentage="true"
            />

            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIs?.gesamtverteilungStatusFrankfurtFern"
              :fillArray="fills"
              :title="'Status FRA: Fern'"
            />
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungFraFernAD"
              :fillArray="fillsStatusNachBearbeitung"
              :doNotShowTypes="['Aufpreis <200', 'Total']"
              :title="'Status nach Bearbeitung FRA: Fern'"
              :innerLabelSubtitle="'positiv'"
              :totalOverwrite="
                getTotalOverwrite(getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungFraFernAD)
              "
              :ausschlussTyp="ausschlussTypenStatusNachBearbeitung"
              :showPercentage="true"
            />

            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIs?.gesamtverteilungStatusFrankfurtEu"
              :fillArray="fills"
              :title="'Status FRA: EU'"
            />
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungFraEuAD"
              :fillArray="fillsStatusNachBearbeitung"
              :doNotShowTypes="['Aufpreis <200', 'Total']"
              :title="'Status nach Bearbeitung FRA: EU'"
              :innerLabelSubtitle="'positiv'"
              :totalOverwrite="
                getTotalOverwrite(getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungFraEuAD)
              "
              :ausschlussTyp="ausschlussTypenStatusNachBearbeitung"
              :showPercentage="true"
            />

            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIs.gesamtverteilungStatusMuenchenBerlinAD"
              :fillArray="fills"
              :title="'Status MUC/BER: Fern'"
            />
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungMucBerFernAD"
              :fillArray="fillsStatusNachBearbeitung"
              :doNotShowTypes="['Aufpreis <200', 'Total']"
              :title="'Status nach Bearbeitung MUC/BER: Fern'"
              :innerLabelSubtitle="'positiv'"
              :totalOverwrite="
                getTotalOverwrite(getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungMucBerFernAD)
              "
              :ausschlussTyp="ausschlussTypenStatusNachBearbeitung"
              :showPercentage="true"
            />

            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIs?.gesamtverteilungStatusMucBerEU"
              :fillArray="fills"
              :title="'Status MUC/BER: EU'"
            ></DoughnutChart>
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungMucBerEuAD"
              :fillArray="fillsStatusNachBearbeitung"
              :doNotShowTypes="['Aufpreis <200', 'Total']"
              :title="'Status nach Bearbeitung MUC/BER: EU'"
              :innerLabelSubtitle="'positiv'"
              :totalOverwrite="
                getTotalOverwrite(getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungMucBerEuAD)
              "
              :ausschlussTyp="ausschlussTypenStatusNachBearbeitung"
              :showPercentage="true"
            />

            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIs?.gesamtverteilungStatusVieZrhFern"
              :fillArray="fills"
              :title="'Status VIE/ZRH: FERN'"
            ></DoughnutChart>
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungVieZrhFernAD"
              :fillArray="fillsStatusNachBearbeitung"
              :doNotShowTypes="['Aufpreis <200', 'Total']"
              :title="'Status nach Bearbeitung VIE/ZRH: FERN'"
              :innerLabelSubtitle="'positiv'"
              :totalOverwrite="
                getTotalOverwrite(getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungVieZrhFernAD)
              "
              :ausschlussTyp="ausschlussTypenStatusNachBearbeitung"
              :showPercentage="true"
            />

            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIs?.gesamtverteilungStatusVieZrhEU"
              :fillArray="fills"
              :title="'Status VIE/ZRH: EU'"
            ></DoughnutChart>
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungVieZrhEuAD"
              :fillArray="fillsStatusNachBearbeitung"
              :doNotShowTypes="['Aufpreis <200', 'Total']"
              :title="'Status nach Bearbeitung VIE/ZRH: EU'"
              :innerLabelSubtitle="'positiv'"
              :totalOverwrite="
                getTotalOverwrite(getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungVieZrhEuAD)
              "
              :ausschlussTyp="ausschlussTypenStatusNachBearbeitung"
              :showPercentage="true"
            />

            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIs?.gesamtverteilungStatusHamDusEu"
              :fillArray="fills"
              :title="'Status HAM/DUS: EU'"
            ></DoughnutChart>
            <DoughnutChart
              style="min-width: 500px; height: 400px"
              :data="isBusy ? [] : getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungHamDusEuAD"
              :fillArray="fillsStatusNachBearbeitung"
              :doNotShowTypes="['Aufpreis <200', 'Total']"
              :title="'Status nach Bearbeitung HAM/DUS: EU'"
              :innerLabelSubtitle="'positiv'"
              :totalOverwrite="
                getTotalOverwrite(getLeadingKPIsStatusNachBearbeitung.statusNachBearbeitungHamDusEuAD)
              "
              :ausschlussTyp="ausschlussTypenStatusNachBearbeitung"
              :showPercentage="true"
            />
          </div>
        </div>
      </b-overlay>
    </template>
  </FilterOverview>
</template>

<script>
import { AgChartsVue } from 'ag-charts-vue';
import DoughnutChart from '@/components/flugverfuegbarkeit/doughnut-chart.vue';
import KPIFilter from '@/components/flugverfuegbarkeit/kpi-filter.vue';
import BarChart from '@/components/flugverfuegbarkeit/bar-chart.vue';
import FilterOverview from '@/components/common/filter-overview.vue';
import FilterDrawer from '@/components/common/filter-drawer.vue';
import { Funnel, FunnelX } from 'lucide-vue';
import {
  GET_DATA_WITH_ALL_GROUPINGS,
  SET_ZEITRAUM_FILTER,
  RESET_ALL_FILTERS,
} from '@/core/flugverfuegbarkeit/stores/kpi-fvc.module';
import { mapGetters, mapState } from 'vuex';
import DateRangePicker from '@/components/common/date-range-picker.vue';
import SimpleProgressChart from '@/components/flugverfuegbarkeit/simple-progress-chart.vue';

export default {
  components: {
    DoughnutChart,
    BarChart,
    FilterOverview,
    FilterDrawer,
    KPIFilter,
    DateRangePicker,
    Funnel,
    FunnelX,
    AgChartsVue,
    SimpleProgressChart,
  },
  data() {
    return {
      fills: ['#ebcc87', '#c16068', '#DAA17B', '#a2bf8a'],
      fillsStatusNachBearbeitung: [
        '#ebcc87',
        '#a2bf8a',
        '#FF7477',
        '#00A878',
        '#c16068',
        '#f4e285',
        '#8cb369',
        '#f94144',
      ],
      kpiSites: ['Dashboard', 'Leading', 'Historie'],
      showFilter: false,
      ausschlussTypenStatusNachBearbeitung: [
        'RQs Verf. n. geschaffen',
        'Ns Verf. n. geschaffen',
        'Aufpreis >200 Verf. n. geschaffen',
        'Total',
      ],
    };
  },
  computed: {
    ...mapGetters(['getLeadingKPIs', 'getLeadingKPIsStatusNachBearbeitung', 'isAnyKpiFilterApplied']),
    ...mapState({
      isBusy: state => state.kpiFvc.isBusy,
      zeitraumSelected: state => state.kpiFvc.filters.zeitraum,
    }),
  },
  created() {
    if (this.getLeadingKPIs === null) this.$store.dispatch(GET_DATA_WITH_ALL_GROUPINGS);
  },
  // Filter gelten nur solange die Seite offen ist, beim Verlassen werden sie geleert
  destroyed() {
    this.$store.commit(RESET_ALL_FILTERS);
  },
  methods: {
    onResetFilter() {
      this.$store.commit(RESET_ALL_FILTERS);
      this.showFilter = false;
    },
    onRegionFilterClick($event) {
      const { id } = $event.target;
      if (this.activeButton !== id) {
        this.activeButton = id;
      }
    },
    changeRegionsmanagerFilter(kuerzel) {
      this.regionsmanagerFilterSelected = kuerzel;
    },
    setZeitraum(start, end) {
      if (start !== this.zeitraumSelected.start && end !== this.zeitraumSelected.end) {
        this.$store.commit(SET_ZEITRAUM_FILTER, {
          start: start || null,
          end: end || null,
        });
        this.$store.dispatch(GET_DATA_WITH_ALL_GROUPINGS);
      }
    },
    getTotalOverwrite(dataStatusNachBearbeitung) {
      return dataStatusNachBearbeitung.find(item => item.type === 'Total').count;
    },
  },
};
</script>
